// utils/auth.js
import api from 'api/axios';

export function isAuthed() {
  return localStorage.getItem('auth_ok') === '1';
}

export function setAuthed(v) {
  if (v) localStorage.setItem('auth_ok', '1');
  else localStorage.removeItem('auth_ok');
}

export async function logout() {
  try {
    await api.post('/api/logout', {});
  } catch (e) {}

  setAuthed(false);
  localStorage.removeItem('token');
}
